module.exports = __webpack_public_path__ + "static/media/FT-MANO-CEL-AR.bdfccba5.png";